import { defineMessages } from 'react-intl';

export const servicePlanTermsMessages = defineMessages({
    servicePlanTerms: {
        id: 'service-plan-terms',
        defaultMessage: 'Service plan terms',
    },
    terms: {
        id: 'terms',
        defaultMessage: 'Terms',
    },
    term: {
        id: 'term',
        defaultMessage: 'Term',
    },
    createServicePlanTermSuccess: {
        id: 'create-service-plan-term-success',
        defaultMessage: 'Service plan term created',
    },
    createServicePlanTermSuccessDescription: {
        id: 'create-service-plan-term-success-description',
        defaultMessage: 'A service plan term has been successfully created.',
    },
    addServicePlanTermSubtitle: {
        id: 'add-service-plan-term-subtitle',
        defaultMessage: 'Create a new service plan term',
    },
    trialPeriodDays: {
        id: 'trial-period-days',
        defaultMessage: 'Trial period days',
    },
    unpaidGracePeriodDays: {
        id: 'unpaid-grace-period-days',
        defaultMessage: 'Unpaid grace period days',
    },
    lockWarningDays: {
        id: 'lock-warning-days',
        defaultMessage: 'Lock warning days',
    },
    lockGracePeriodDays: {
        id: 'lock-grace-period-days',
        defaultMessage: 'Lock grace period days',
    },
    stopWarningDays: {
        id: 'stop-warning-days',
        defaultMessage: 'Stop warning days',
    },
    stopGracePeriodDays: {
        id: 'stop-grace-period-days',
        defaultMessage: 'Stop grace period days',
    },
    deleteServicePlanTerm: {
        id: 'delete-service-plan-term',
        defaultMessage: 'Delete service plan term',
    },
    deleteServicePlanTermSuccess: {
        id: 'delete-service-plan-term-success',
        defaultMessage: 'Service plan term deleted',
    },
    deleteServicePlanTermSuccessDescription: {
        id: 'delete-service-plan-term-success-description',
        defaultMessage: 'The service plan term has been successfully deleted.',
    },
    confirmDeleteServicePlanTerm: {
        id: 'confirm-delete-service-plan-term',
        defaultMessage: 'Are you sure you want to delete this service plan term? This action cannot be undone.',
    },
    deleteServicePlanTermSubtitle: {
        id: 'delete-service-plan-term-subtitle',
        defaultMessage: 'Permanently delete service plan term',
    },
    editServicePlanTermSubtitle: {
        id: 'edit-service-plan-term-subtitle',
        defaultMessage: 'Edit service plan term',
    },
    updateServicePlanTermSuccess: {
        id: 'update-service-plan-term-success',
        defaultMessage: 'Service plan term updated',
    },
    updateServicePlanTermSuccessDescription: {
        id: 'update-service-plan-term-success-description',
        defaultMessage: 'The service plan term has been successfully updated.',
    },
    overlappingDateError: {
        id: 'custom-error:overlapping_date_range',
        defaultMessage: 'The selected date range overlaps with an existing period!',
    },
    deleteServicePlanTermError: {
        id: 'custom-error:delete_terms_used_in_active_service_plan',
        defaultMessage: 'Cannot delete terms that are currently used in active service plan!',
    },
});
